import { useCallback, useEffect, useState } from 'react'

type CenterMode = 'preview' | 'split' | 'editor'

export function useEditorJsonInvalid(activeCenterMode: CenterMode): {
  isEditorJsonInvalid: boolean
  onJsonValidityChange: (isValid: boolean) => void
} {
  const [isEditorJsonInvalid, setIsEditorJsonInvalid] = useState(false)

  useEffect(() => {
    // The editor unmounts when activeCenterMode is 'preview'. Without this reset,
    // isEditorJsonInvalid stays true permanently with no editor visible to fix it.
    if (activeCenterMode === 'preview') {
      setIsEditorJsonInvalid(false)
    }
  }, [activeCenterMode])

  const onJsonValidityChange = useCallback((isValid: boolean) => {
    setIsEditorJsonInvalid(!isValid)
  }, [])

  return {
    isEditorJsonInvalid,
    onJsonValidityChange,
  }
}
